"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupTranslation = void 0;
var i18next_1 = __importDefault(require("i18next"));
var i18next_icu_1 = __importDefault(require("i18next-icu"));
var moment_1 = __importDefault(require("moment"));
require("moment/locale/de");
require("moment/locale/fr");
var react_i18next_1 = require("react-i18next");
function setupTranslation(translations, options) {
    i18next_1.default.use(react_i18next_1.initReactI18next).use(i18next_icu_1.default);
    var query = new URLSearchParams(window.location.search);
    var locale = query.get('locale') || 'en';
    i18next_1.default.init(__assign({ lng: locale, debug: process.env.NODE_ENV === 'development', fallbackLng: 'en', keySeparator: false, nsSeparator: false, resources: translations }, options)).catch(function (error) { return console.error(error); });
    moment_1.default.locale(locale);
}
exports.setupTranslation = setupTranslation;
//# sourceMappingURL=TranslationSetup.js.map